import { memo } from 'react';
import { Box } from '@mui/material';
import styled from 'styled-components';

const TooltipButtonContent = styled(Box)`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 0 ${({ theme }) => theme.spacing.m1};
`;

export default memo(TooltipButtonContent);
